export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/stepCarDetails.0e4463bc.svg","height":44,"width":44,"blurWidth":0,"blurHeight":0};